import { Card, type CardProps } from '@/components/ui/card.tsx';
import { ProgressBarStepper } from '@/views/layouts/ProgressBarStepper.tsx';

type Props = CardProps & {
  currentStep: number;
  totalSteps: number;
};

export default function StepperCard({ currentStep, totalSteps, ...props }: Props) {
  const showStepper = currentStep !== undefined && totalSteps !== undefined;

  return (
    <>
      {showStepper && <ProgressBarStepper currentStep={currentStep} totalSteps={totalSteps} />}
      {/* Subtract 2 from top margin to fit stepper */}
      <Card className="rounded-t-none rounded-b-md pt-6 sm:pt-9.5" {...props} />
    </>
  );
}
